import React, { useEffect, useState } from 'react'
import { Table, message } from 'antd'
import axios from 'axios'
import { useNavigate } from 'react-router-dom'
import 'src/Pages/LibraryPages/librarypages.scss'

const ProgressReport = () => {
  const token = localStorage.getItem('token')
  const [reports, setReports] = useState([])
  const [loading, setLoading] = useState(false)
  const [page, setPage] = useState(1)
  const [pageSize, setPageSize] = useState(10)
  const [total, setTotal] = useState(0)
  const navigate = useNavigate()

  useEffect(() => {
    fetchReports()
  }, [page, pageSize])

  const fetchReports = async () => {
    setLoading(true)
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL_API}/InternshipStatusReport/Mentor`,
        {
          headers: {
            Accept: '*/*',
            Authorization: `Bearer ${token}`,
          },
          params: { pageNumber: page, pageSize },
        },
      )
      // Server-side pagination: base endpoint (no /lookup) returns { items, totalCount }.
      const d = response.data
      if (Array.isArray(d)) {
        setReports(d)
        setTotal(d.length)
      } else {
        setReports(d?.items ?? [])
        setTotal(d?.totalCount ?? 0)
      }
    } catch (error) {
      message.error('Failed to fetch data. Please try again.')
      console.error('Error fetching reports:', error)
    } finally {
      setLoading(false)
    }
  }

  const handleViewDetails = (reportId) => {
    navigate(`/progress-report-detail/${reportId}`) // Navigate with reportId
  }

  const columns = [
    {
      title: 'Student Name',
      dataIndex: 'studentName',
      key: 'studentName',
    },
    {
      title: 'Week Number',
      dataIndex: 'weekNumber',
      key: 'weekNumber',
    },
    {
      title: 'Submission Date',
      dataIndex: 'submissionDate',
      key: 'submissionDate',
      render: (date) => new Date(date).toLocaleString(),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <button
          type="button"
          className="lpg__btn-primary"
          onClick={() => handleViewDetails(record.reportId)}
        >
          View Details
        </button>
      ),
    },
  ]

  return (
    <div className="lpg">
      <div className="lpg__head">
        <div className="lpg__head-main">
          <span className="lpg__head-ic">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M3 3v18h18" />
              <path d="M7 15l3-4 3 3 4-6" />
            </svg>
          </span>
          <div>
            <h1 className="lpg__title">Progress Report</h1>
            <p className="lpg__sub">Project progress reports.</p>
          </div>
        </div>
        <button type="button" className="lpg__back" onClick={() => navigate('/projects')}>
          <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.4"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M19 12H5M11 18l-6-6 6-6" />
          </svg>{' '}
          Back
        </button>
      </div>

      {loading ? (
        <div className="lpg__state">
          <div className="lpg__spin" />
          Loading...
        </div>
      ) : (
        <div className="lpg__panel-box">
          <Table
            columns={columns}
            dataSource={reports}
            rowKey={(r) => r.id ?? r.reportId}
            pagination={{
              current: page,
              pageSize,
              total,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30'],
              onChange: (p, s) => {
                setPage(p)
                setPageSize(s)
              },
            }}
          />
        </div>
      )}
    </div>
  )
}

export default ProgressReport
